'use strict';

import { cn_element_type_visitor } from '../utils/visitors/cn_element_type_visitor';
//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************
//***********************************************************************************
//***********************************************************************************
//**** Misc Multi-Material Composition
//***********************************************************************************
//***********************************************************************************
import { cn_element_type_layer_material } from './cn_element_type_layer_material';
import { cn_material } from './cn_material';
import { cn_material_type } from './cn_material_type';

export class cn_mmm_composition extends cn_element_type_layer_material {

    /**
     * @param {import('./cn_building').cn_building} parent
     */
    constructor(parent) {
        super(parent);
        this.class_name = 'cn_mmm_composition';
        this.name = "";
        this.layers = [];
        let existing_materials = parent.get_material_types();
        if (existing_materials.length)
            this.layers = [new cn_material(parent,existing_materials[0],0.1)];
        
        this.is_expert = true;
    }

    //***********************************************************************************
    //**** Clone
    //***********************************************************************************
    /**
     * @returns {cn_mmm_composition}
     */
    clone() {
        // NB : material type must not be cloned !
        let composition = new cn_mmm_composition(this.parent);
        composition.layers = this.layers.map(m => m.clone());
        composition.name = this.name;
        return composition;
    }

    //***********************************************************************************
    //**** keys
    //***********************************************************************************
    model_keys() {
        return ['name', 'layers'];
    }

    //***********************************************************************************
    //**** serialize
    //***********************************************************************************

    serialize() {
        let json = this.serialize_element();
        json.class_name = 'cn_mmm_composition';
        json.name = this.name;
        json.layers = this.layers.map(m => m.serialize());
        return json;
    }

    /**
     * @param {any} json
     * @param {import('./cn_building').cn_building} building
     * @returns {cn_mmm_composition}
     */
    static unserialize(json, building) {
        let composition = new cn_mmm_composition(building);
        composition.unserialize_element(json);
        if (typeof (json.name) == 'string') 
            composition.name = json.name;

        composition.layers = json.layers.map(m => cn_material.unserialize(m,building)).filter(m => !!m);
        
        return composition;
    }

    //***********************************************************************************
    //**** default material types
    //***********************************************************************************
    static default_types(building) {
        let insulated = new cn_mmm_composition(building);
        insulated.layers = [];
        insulated.layers.push(new cn_material(parent,cn_material_type.material_type_by_code("gypsum"),0.01));
        insulated.layers.push(new cn_material(parent,cn_material_type.material_type_by_code("styrofoam"),0.05));
        return [
            new cn_mmm_composition(building)
        ];
    }

    //***********************************************************************************
    //**** returns label
    //***********************************************************************************
    get_label() {
        if (this.name != '') return this.name;

        var element_type_name = '';
        
        if (this.layers.length) {
            this.layers.forEach((layer,i) => {
                if (!layer.material_type) return;
                if (i > 0) element_type_name += "/";
                element_type_name += layer.name;
            });
        }
        else element_type_name = "Générique"

        element_type_name += ' ' + (this.thickness * 100).toFixed(0) + 'cm';

           
        return element_type_name;
    }

    /**
     * Returns an array of objects describing the type.
     * @returns {{label: string, value?: any, decimals?: number, unit?: string}[]}
     */
    get_description() {
        var description = [];

        var th = { label: 'Epaisseur' };
        th.value = this.thickness * 100;
        th.decimals = 1;
        th.unit = 'cm';
        description.push(th);

        var layers = { label: 'Matériaux' };
        description.push(layers);
        layers.value = [];

        for (var i in this.layers) {
            layers.value.push(this.layers[i].get_label());
        }

        return description;
    }
    //***********************************************************************************
    //**** draw
    //***********************************************************************************
    draw_svg_icon(widtho, heighto) {
        if (this.is_null) return super.draw_svg_icon(widtho, heighto);
        let svg=`<svg x="0" y="0" width="${widtho}" height="${heighto}" style="overflow:hidden">`;

        svg += '<g transform=\'translate(' + (widtho / 2) + ',' + (heighto / 2) + ') rotate(90) translate(' + (-0.5 * widtho) + ',' + (-0.5 * heighto) + ') \'>';

        const width = heighto;
        const height = widtho;

        let full_width = 0;
        this.layers.forEach(m => full_width += m .thickness);

        let scale = height;

        let pos = [scale*(0.5 - full_width * 0.5),0];
        this.layers.forEach(m => {
            let x0 = pos[0];
            let x1 = x0 + scale * m.thickness;
            svg += m.draw_material(pos,x1-x0,height,scale);
            svg += `<line x1="${x0}" y1="0" x2="${x0}" y2="${height}" stroke="black" />`;
            pos[0] = x1;
        });
        svg += `<line x1="${pos[0]}" y1="0" x2="${pos[0]}" y2="${height}" stroke="black" />`;

        return svg + `</g></svg>`;
    }
    
    /**
     * Accept element type visitor
     *
     * @param {cn_element_type_visitor} element_type_visitor
     */
    accept_visitor(element_type_visitor) {
        element_type_visitor.visit_mmm_composition(this);
    }

}

